import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useRef, useState, useCallback, useMemo } from 'react';
import { Styled } from './styled.es.js';
import { TableHead } from './TableHead.es.js';
import { TableBody } from './TableBody.es.js';
import { TableFoot } from './TableFoot.es.js';
import { TableRow } from './TableRow.es.js';
import { TableCell } from './TableCell.es.js';
import { TableContext } from './TableContext.es.js';
import { TABLE_EVENTS } from './Table.constants.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Table = function Table(_a) {
  var _b = _a,
      children = _b.children,
      _b$listenKeyEvents = _b.listenKeyEvents,
      listenKeyEvents = _b$listenKeyEvents === void 0 ? false : _b$listenKeyEvents,
      _b$stickyHeader = _b.stickyHeader,
      stickyHeader = _b$stickyHeader === void 0 ? false : _b$stickyHeader,
      _b$isRuled = _b.isRuled,
      isRuled = _b$isRuled === void 0 ? false : _b$isRuled,
      onRowChange = _b.onRowChange,
      focusedRowIndexRef = _b.focusedRowIndexRef,
      props = __objRest(_b, ["children", "listenKeyEvents", "stickyHeader", "isRuled", "onRowChange", "focusedRowIndexRef"]);

  var defaultFocusedRowIndexRef = useRef(-1);

  var _useState = useState(),
      tableBodyNode = _useState[0],
      setBodyNode = _useState[1];

  var dispatchRowChangedEvent = useCallback(function (newRowIndex, didKeyboardNav) {
    tableBodyNode == null ? void 0 : tableBodyNode.dispatchEvent(new CustomEvent(TABLE_EVENTS.ROW_CHANGED, {
      detail: {
        newRowIndex: newRowIndex,
        didKeyboardNav: didKeyboardNav
      }
    }));
  }, [tableBodyNode]);
  var tableContext = useMemo(function () {
    return {
      dispatchRowChangedEvent: dispatchRowChangedEvent,
      focusedRowIndexRef: focusedRowIndexRef || defaultFocusedRowIndexRef,
      isRuled: isRuled,
      listenKeyEvents: listenKeyEvents,
      onRowChange: onRowChange,
      setBodyNode: setBodyNode,
      stickyHeader: stickyHeader,
      tableBodyNode: tableBodyNode
    };
  }, [dispatchRowChangedEvent, focusedRowIndexRef, isRuled, listenKeyEvents, onRowChange, setBodyNode, stickyHeader, tableBodyNode]);
  return (
    /* @__PURE__ */
    React.createElement(TableContext.Provider, {
      value: tableContext
    },
    /* @__PURE__ */
    React.createElement(Styled.Table, __spreadValues({}, props), children))
  );
};

Table.displayName = "Table";
Table.Head = TableHead;
Table.Body = TableBody;
Table.Foot = TableFoot;
Table.Row = TableRow;
Table.Cell = TableCell;

var DoczTableProps = function DoczTableProps() {
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null)
  );
};

export { DoczTableProps, Table };